import { render, staticRenderFns } from "./CandidatesNote.vue?vue&type=template&id=001b4c85&scoped=true&lang=pug"
import script from "./CandidatesNote.vue?vue&type=script&lang=js"
export * from "./CandidatesNote.vue?vue&type=script&lang=js"
import style0 from "./CandidatesNote.vue?vue&type=style&index=0&id=001b4c85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001b4c85",
  null
  
)

export default component.exports